import * as yup from 'yup'
import moment from 'moment'

export const validationSchema = yup.object().shape({
  health_insurance_name: yup.string().required(),
  health_insurance_code: yup.string().required(),
  // health_plan_name: yup.string().required(),
  // health_plan_code: yup.string().required(),
  health_card: yup.string().max(25, 'Máximo de 25 caracteres').required(),
  // company_name: yup.string(),
  valid_thru: yup
    .date()
    .typeError('Data Inválida')
    .min(moment().utc(), 'A data precisa ser maior que a data atual')
    .format('DD/MM/YYYY', true)
  // .required()
})
